import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.3281 43.7802H32.2076V45.243H31.3281V43.7802ZM30.1895 45.2607V42.6416H33.3462V45.2607H41.5261C41.8405 45.2607 42.0954 45.5156 42.0954 45.8301C42.0954 46.1445 41.8405 46.3994 41.5261 46.3994H22.0127C21.6982 46.3994 21.4434 46.1445 21.4434 45.8301C21.4434 45.5156 21.6982 45.2607 22.0127 45.2607H30.1895Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.9346 42.0067C42.5412 42.1058 42.1468 42.1996 41.7515 42.288C35.1805 43.7587 28.3654 43.7587 21.7944 42.288C21.3991 42.1996 21.0047 42.1058 20.6113 42.0067L31.773 25.4209L42.9346 42.0067ZM41.0677 41.272L31.773 27.4603L22.4782 41.272C28.6056 42.5792 34.9403 42.5792 41.0677 41.272Z"
      className="mainColor"
    />
    <path
      d="M31.7711 22.3838L40.2824 34.7609Lnan nanL40.2824 34.7609C34.799 36.842 28.7431 36.842 23.2598 34.7609Lnan nanL23.2598 34.7609L31.7711 22.3838Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.2824 34.7609C39.9139 34.9007 39.5429 35.0312 39.1696 35.1522C34.361 36.7116 29.1811 36.7116 24.3725 35.1522C23.9993 35.0312 23.6282 34.9007 23.2598 34.7609L31.7711 22.3838L40.2824 34.7609ZM38.4951 34.1713L31.7711 24.3933L25.0471 34.1713C29.4277 35.5204 34.1144 35.5204 38.4951 34.1713Z"
      className="mainColor"
    />
    <path
      d="M31.7708 20.2334L37.7896 28.6525Lnan nanL37.7896 28.6525C33.9749 30.4347 29.5666 30.4347 25.752 28.6525Lnan nanL25.752 28.6525L31.7708 20.2334Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.7896 28.6525C37.4352 28.8181 37.0757 28.9682 36.712 29.103C33.5246 30.2845 30.0169 30.2845 26.8295 29.103C26.4658 28.9682 26.1063 28.8181 25.752 28.6525L31.7708 20.2334L37.7896 28.6525ZM36.0235 28.14L31.7708 22.1912L27.518 28.14C30.2732 29.0873 33.2683 29.0873 36.0235 28.14Z"
      className="mainColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.7702 17.6006C32.0846 17.6006 32.3395 17.8555 32.3395 18.1699V18.755L32.845 18.4632C33.1172 18.306 33.4654 18.3993 33.6226 18.6716C33.7799 18.9439 33.6866 19.2921 33.4143 19.4493L32.9093 19.7408L33.4149 20.0327C33.6872 20.1899 33.7805 20.5381 33.6232 20.8104C33.466 21.0827 33.1178 21.176 32.8455 21.0188L32.3395 20.7266V21.3133C32.3395 21.6278 32.0846 21.8827 31.7702 21.8827C31.4558 21.8827 31.2009 21.6278 31.2009 21.3133V20.7272L30.692 21.021C30.4197 21.1782 30.0715 21.0849 29.9143 20.8126C29.757 20.5403 29.8503 20.1921 30.1226 20.0349L30.632 19.7408L30.1232 19.4471C29.8509 19.2899 29.7576 18.9417 29.9149 18.6694C30.0721 18.3971 30.4203 18.3038 30.6926 18.461L31.2009 18.7545V18.1699C31.2009 17.8555 31.4558 17.6006 31.7702 17.6006Z"
      className="mainColor"
    />
    <path
      d="M27.2509 31.7348C27.2509 32.5209 26.6136 33.1581 25.8276 33.1581C25.0415 33.1581 24.4043 32.5209 24.4043 31.7348C24.4043 30.9487 25.0415 30.3115 25.8276 30.3115C26.6136 30.3115 27.2509 30.9487 27.2509 31.7348Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8285 30.8798C25.3569 30.8798 24.9746 31.2622 24.9746 31.7338C24.9746 32.2054 25.3569 32.5878 25.8285 32.5878C26.3002 32.5878 26.6825 32.2054 26.6825 31.7338C26.6825 31.2622 26.3002 30.8798 25.8285 30.8798ZM23.8359 31.7338C23.8359 30.6333 24.7281 29.7412 25.8285 29.7412C26.929 29.7412 27.8211 30.6333 27.8211 31.7338C27.8211 32.8343 26.929 33.7264 25.8285 33.7264C24.7281 33.7264 23.8359 32.8343 23.8359 31.7338Z"
      className="mainColor"
    />
    <ellipse
      cx="19.7197"
      cy="23.9961"
      rx="0.569313"
      ry="0.569313"
      className="mainColor"
    />
    <ellipse
      cx="38.6689"
      cy="22.5742"
      rx="0.569313"
      ry="0.569313"
      className="mainColor"
    />
    <ellipse
      cx="44.2803"
      cy="25.4199"
      rx="0.569313"
      ry="0.569313"
      className="mainColor"
    />
    <ellipse
      cx="25.3955"
      cy="20.3105"
      rx="0.569313"
      ry="0.569313"
      className="mainColor"
    />
    <ellipse
      cx="21.4443"
      cy="30.3105"
      rx="0.569313"
      ry="0.569313"
      className="mainColor"
    />
    <ellipse
      cx="42.8252"
      cy="34.1426"
      rx="0.569313"
      ry="0.569313"
      className="mainColor"
    />
    <path
      d="M35.9774 24.85C35.9774 25.6361 35.3402 26.2733 34.5541 26.2733C33.7681 26.2733 33.1309 25.6361 33.1309 24.85C33.1309 24.064 33.7681 23.4268 34.5541 23.4268C35.3402 23.4268 35.9774 24.064 35.9774 24.85Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.557 23.997C34.0854 23.997 33.7031 24.3794 33.7031 24.851C33.7031 25.3226 34.0854 25.705 34.557 25.705C35.0287 25.705 35.411 25.3226 35.411 24.851C35.411 24.3794 35.0287 23.997 34.557 23.997ZM32.5645 24.851C32.5645 23.7505 33.4566 22.8584 34.557 22.8584C35.6575 22.8584 36.5496 23.7505 36.5496 24.851C36.5496 25.9515 35.6575 26.8436 34.557 26.8436C33.4566 26.8436 32.5645 25.9515 32.5645 24.851Z"
      className="mainColor"
    />
    <path
      d="M40.9462 38.6254C40.9462 39.4115 40.3089 40.0487 39.5229 40.0487C38.7368 40.0487 38.0996 39.4115 38.0996 38.6254C38.0996 37.8394 38.7368 37.2021 39.5229 37.2021C40.3089 37.2021 40.9462 37.8394 40.9462 38.6254Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5219 37.7724C39.0503 37.7724 38.6679 38.1547 38.6679 38.6264C38.6679 39.098 39.0503 39.4804 39.5219 39.4804C39.9935 39.4804 40.3759 39.098 40.3759 38.6264C40.3759 38.1547 39.9935 37.7724 39.5219 37.7724ZM37.5293 38.6264C37.5293 37.5259 38.4214 36.6338 39.5219 36.6338C40.6224 36.6338 41.5145 37.5259 41.5145 38.6264C41.5145 39.7269 40.6224 40.619 39.5219 40.619C38.4214 40.619 37.5293 39.7269 37.5293 38.6264Z"
      className="mainColor"
    />
    <path
      d="M28.8095 42.1938C28.8095 42.9798 28.1722 43.6171 27.3862 43.6171C26.6001 43.6171 25.9629 42.9798 25.9629 42.1938C25.9629 41.4077 26.6001 40.7705 27.3862 40.7705C28.1722 40.7705 28.8095 41.4077 28.8095 42.1938Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.3871 41.3408C26.9155 41.3408 26.5332 41.7231 26.5332 42.1947C26.5332 42.6664 26.9155 43.0487 27.3871 43.0487C27.8588 43.0487 28.2411 42.6664 28.2411 42.1947C28.2411 41.7231 27.8588 41.3408 27.3871 41.3408ZM25.3945 42.1947C25.3945 41.0943 26.2866 40.2021 27.3871 40.2021C28.4876 40.2021 29.3797 41.0943 29.3797 42.1947C29.3797 43.2952 28.4876 44.1873 27.3871 44.1873C26.2866 44.1873 25.3945 43.2952 25.3945 42.1947Z"
      className="mainColor"
    />
    <path
      d="M33.3505 35.7797C33.3505 36.5658 32.7132 37.203 31.9272 37.203C31.1411 37.203 30.5039 36.5658 30.5039 35.7797C30.5039 34.9937 31.1411 34.3564 31.9272 34.3564C32.7132 34.3564 33.3505 34.9937 33.3505 35.7797Z"
      className="bgColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.9242 34.9248C31.4526 34.9248 31.0703 35.3071 31.0703 35.7787C31.0703 36.2504 31.4526 36.6327 31.9242 36.6327C32.3959 36.6327 32.7782 36.2504 32.7782 35.7787C32.7782 35.3071 32.3959 34.9248 31.9242 34.9248ZM29.9316 35.7787C29.9316 34.6782 30.8238 33.7861 31.9242 33.7861C33.0247 33.7861 33.9168 34.6782 33.9168 35.7787C33.9168 36.8792 33.0247 37.7713 31.9242 37.7713C30.8238 37.7713 29.9316 36.8792 29.9316 35.7787Z"
      className="mainColor"
    />
  </svg>
);

const HolidayLightingIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default HolidayLightingIcon;
